import { render, staticRenderFns } from "./ChatbotSupportSurveyEvaluateCountChart.vue?vue&type=template&id=22e2cb44"
import script from "./ChatbotSupportSurveyEvaluateCountChart.vue?vue&type=script&lang=js"
export * from "./ChatbotSupportSurveyEvaluateCountChart.vue?vue&type=script&lang=js"
import style0 from "./ChatbotSupportSurveyEvaluateCountChart.vue?vue&type=style&index=0&id=22e2cb44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports